import { render } from "./attachment.vue?vue&type=template&id=0fef828e"
import script from "./attachment.js?vue&type=script&lang=js"
export * from "./attachment.js?vue&type=script&lang=js"

import "./attachment.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__